<template>
  <div class="welfare">
    <Header :isbig="true" @changeLogin="changeLogin"></Header>
    <div class="welfareCon">
      <div class="section section1 mt0 m-b-0">
        <img :src="require(`@/assets/welfare/fuli_${$i18n.locale}_img1.png`)"/>
<!--        <el-button class="time-btn f18 font-s-s" type="success" round>Duration：01/01/2023-12/30/2023</el-button>-->
      </div>
      <div class="section section2" v-if="lang === 'en_US' || lang === 'en_ID'">
        <img :src="require(`@/assets/welfare/fuli_${$i18n.locale}_img2.png`)"/>
      </div>
      <div class="zw-wrap" v-if="lang === 'zh_CN'">
        <div class="fuli-title">2025年平台作者签约福利</div>
        <div class="fuli-content">
          <ul>
            <li class="qianyue-title">签约对象：</li>
            <li>1.曾在国内各大中短平台、长篇小说有过突出成绩的成熟作者</li>
            <li>2、作品有外站数据的优质作者</li>
            <li>3、有海外小说写作签约、完本经验的作者</li>
            <li>4、萌新作者</li>
          </ul>
          <ul>
            <li class="qianyue-title">签约价格：</li>
            <li>1、全版权独家买断或保底千字15人民币起，上不封顶，超保底后，按50%分成</li>
            <li>2、纯分成，产生收益后扣除运营成本50%分成</li>
          </ul>
          <ul>
            <li class="qianyue-title">签约说明：</li>
            <li>1、投稿字数要求：
              <div class="qianyue-detail">
                <p>中篇：全文不低于3万字，6000开篇+后续大纲投稿</p>
                <p>长篇：全文开篇1万字+后续大纲投稿</p>
              </div>
            </li>
            <li>2、投稿提供历史数据、外站链接</li>
            <li>3、禁止一稿多投、禁止搬运抄袭</li>
            <li>4、签约成功后，次月10-20号左右发放稿费，国内主体发放稿费，正常报税</li>
          
          </ul>
          <ul>
            <li class="qianyue-title">投稿邮箱：</li>
            <li>
              <span>总编：</span>
              <span>奶糖Kale </span>
              <span>1914750183@qq.com</span>
            </li>
            <li>
              <span>主编：</span>
              <span>Kayla </span>
              <span>105237921@qq.com</span>
            </li>
            <li>
              <span>责编：</span>
              <span>乌冬 </span>
              <span>3629320659@qq.com</span>
            </li>
            <li>
              <span class="zhanwei">涂涂 </span>
              <span>3267173246@qq.com</span>
            </li>
          </ul>
        </div>
      </div> 
    </div>
    <Footer :big="true"></Footer>
    <Login @changeLogin="changeLogin" v-if="isshowlogin"></Login>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: localStorage.getItem('language') || 'en_US',
    }
  },
};
</script>

<style lang="scss" scoped>
  .welfare{
    .section{
      width: 1200px;
      margin: auto;
      img{
        width: 100%;
      }
      &.section1{
        position: relative;
        .time-btn{
          position: absolute;
          top: 43%;
          left: 50%;
          transform: translateX(-50%);
          margin-left: 210px;
        }
      }
      &.section2{
        margin-bottom: 60px;
      }
    }
    .zw-wrap{
      width: 1200px;
      margin: 0 auto;
      color: #fff;
      .fuli-title{
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: #FF049B;
        border-radius: 12px;
        font-family: 'AlimamaFangYuanTiVF';
        font-weight: 600;
        font-size: 26px;
        color: #FFFFFF;
      }
      .fuli-content{
        padding: 0 156px 156px;
        >ul{
          margin-top: 76px;
          li{
            font-family: 'AlimamaFangYuanTiVF';
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 40px;
            &.qianyue-title{
              font-weight: bold;
              font-size: 22px;
              margin-bottom: 4px;
            }
            .qianyue-detail{
              padding-left: 24px;
            }
            .zhanwei{
              margin-left: 48px;
            }
          }
        }
      }
    }
  }
</style>